import { render, staticRenderFns } from "./ResultsReport.vue?vue&type=template&id=5e35549a&scoped=true&lang=pug"
import script from "./ResultsReport.vue?vue&type=script&lang=ts"
export * from "./ResultsReport.vue?vue&type=script&lang=ts"
import style0 from "./ResultsReport.vue?vue&type=style&index=0&id=5e35549a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e35549a",
  null
  
)

export default component.exports